import {Suspense, lazy} from 'react';
const TheCalendar = lazy(() => import(/* webpackChunkName: "ui-components" */'./TheCalendar'));

const Calendar = (props) => {
    return <Suspense fallback={null}>
        <TheCalendar {...props} />
    </Suspense>
}

export default Calendar;
